class ModalDialog {
    constructor() {

    }

    init() {
        let modalDialogTriggerButtons = document.querySelectorAll('button.trigger-button');

        for (let triggerButton of modalDialogTriggerButtons) {
            let closeButton,
                id = triggerButton.getAttribute('aria-controls'),
                dialogMatches = document.querySelectorAll(`dialog#${id}`) ? document.querySelectorAll(`dialog#${id}`) : null,
                dialog;

            // Return early if dialog does not exist
            if (!dialogMatches) return;

            // Return early if dialog's `id` is not unique
            if (dialogMatches.length > 1) return;

            dialog = dialogMatches[0];

            closeButton = dialog.querySelector('button.close-button[aria-controls]');

            // Return early if the value of `aria-controls` doesn't match the parent dialog's `id` value
            if (dialog.id !== closeButton.getAttribute('aria-controls')) return;

            triggerButton.addEventListener('click', () => {
                dialog.showModal();
                closeButton.focus();
            });

            closeButton.addEventListener('click', () => {
                dialog.close();

                triggerButton.focus()
            });
        }
    }
}

export default ModalDialog;